"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Chip = require("../Chip");
require("./ModalImage.css");
var DefaultModalImage = function DefaultModalImage(_ref) {
  var domain = _ref.domain;
  var icon = _Chip.siftIcons[domain];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sift-modal-image bg-secondary text-light"
  }, /*#__PURE__*/_react["default"].cloneElement(icon, {
    style: {
      fontSize: '4rem'
    }
  }));
};
var _default = exports["default"] = DefaultModalImage;
//# sourceMappingURL=DefaultModalImage.js.map